module.exports = vendors_tr_4d9c5b8a6e315fabf97f;